export default __webpack_public_path__ + "static/media/download-24.86f4f407.png";